<style>
.showPerfil {
    cursor: pointer;
    border-bottom: 1px dotted;
}
</style>
<template>
<div id="page-usuarios">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Usuarios Solución A31" class="elevation-1 px-5 py-3">
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <exportar-excel :data="datafiltered" :exportFields="usuarios.camposexcel" name="Usuarios.xlsx">
                            <v-btn fab dark x-small color="success" title="Exportar a Excel" v-tippy>
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                        </exportar-excel>
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid">

                            <v-client-table ref="vuetable" :data="usuarios.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="nombre" slot-scope="props">
                                    <span>{{ props.row.nombre }}</span>
                                </template>

                                <template slot="perfil" slot-scope="props">
                                    <div v-if="props.row.tipo_usuario!='Grupo' && props.row.perfil !== null" @click="openModalPermisos(props.row.perfil)" :class="['showPerfil']">
                                        {{ getNombrePerfil(props.row.perfil) }}
                                    </div>
                                    <div v-else-if="props.row.tipo_usuario=='Grupo'">
                                        {{getNombrePerfil(props.row.perfil)}}
                                    </div>
                                    <div v-else>Administrador</div>
                                </template>
                                <template slot="subtipo" slot-scope="props">
                                    <div v-if="props.row.tipo_usuario!='Grupo'" @click="openModalSubtipo(
                                        props.row.subtipo,
                                        props.row.nombre,
                                        props.row.id
                                        )
                                        " :class="['showPerfil']">
                                        {{ getSubtipo(props.row.subtipo) }}
                                    </div>
                                </template>
                                <template slot="estatus" slot-scope="props">
                                    <div v-if="props.row.estatus">Activo</div>
                                    <div v-if="!props.row.estatus">Inactivo</div>
                                </template>

                                <template slot="actions" slot-scope="props">
                                    <v-speed-dial v-if="props.row.tipo_usuario!='Grupo'" v-model="fab[props.row.id]" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary">
                                                <v-icon v-if="fab[props.row.id]">mdi-close</v-icon>
                                                <v-icon v-else>reorder</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-btn x-small fab dark color="green" v-if="!props.row.estatus" @click.native="changeEstatus(props.row.id, props.row.id_usuario_cliente, true)" title="Activar Usuario" v-tippy>
                                            <v-icon>check</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="orange" v-if="props.row.estatus" @click.native="changeEstatus(props.row.id, props.row.id_usuario_cliente, false)" title="Desactivar Usuario" v-tippy>
                                            <v-icon>block</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getUsuario(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="false" x-small fab dark color="pink" @click.native="deleteUsuario(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="indigo" @click.native="
                          resetPassword(props.row.id, props.row.username)
                        " title="Resetear Contraseña" v-tippy>
                                            <v-icon>lock</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="purple" @click.native="
                          logout(props.row.id)
                        " title="Cerrar Sesión" v-tippy>
                                            <v-icon>report_problem</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modal" max-width="500px">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>&nbsp;
                    <span class="subheading">
                        <strong>{{ update ? "Actualizar" : "Nuevo" }} Usuario</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-card-text>
                <v-form ref="form" lazy-validation>
                    <v-container grid-list-md @keyup.enter="update ? updateUsuario() : saveUsuario()">
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Apellidos" v-model="model.apellidos" :rules="[rules.required]"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Iniciales" v-model="model.iniciales" @input="model.iniciales = model.iniciales.toUpperCase()" maxlength=15 :rules="[rules.required]"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Email" v-model="model.username" :rules="[rules.required, rules.email]"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-select :items="tipos_usuario_select" v-model="model.tipo_usuario" label="Tipo de Usuario" item-text="nombre" item-value="id_tipo_usuario" single-line :rules="[rules.required]"></v-select>
                            </v-flex>
                        </v-layout>
                        <v-flex xs12 v-if="model.tipo_usuario == 2">
                            <v-select :items="perfiles" v-model="model.perfil" item-text="nombre" item-value="id_perfil" label="Perfil" single-line></v-select>
                        </v-flex>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="update ? updateUsuario() : saveUsuario()">
                    <v-icon>done</v-icon> {{ update ? "Actualizar" : "Guardar" }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_permisos" max-width="40%">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <v-icon @click.native="modal_permisos = false" class="white--text">cancel</v-icon>
                    <span class="subheading">
                        <strong>{{ titleModalPermisos }}</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table :items="permisos_perfiles" class="elevation-1" :headers="permisos.headers">
                    <template slot="no-data">
                        <v-alert :value="true" color="error" icon="warning">
                            No hay permisos en este perfil...
                        </v-alert>
                    </template>

                    <template slot="items" slot-scope="permiso">
                        <td>{{ permiso.item.categoria }}</td>
                        <td>{{ permiso.item.nombre }}</td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_subtipo" max-width="45%">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <v-icon @click.native="modal_subtipo = false" class="white--text">cancel</v-icon>
                    <span class="subheading">
                        <strong>{{ titleModalSubtipo }}</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row>
                    <v-flex col xs12 s6 m6 l6>
                        <v-autocomplete :items="subtipos" v-model="subtipoSelected" label="Seleccione un subtipo" item-text="subtipo" item-value="id_catalogo_subtipo" :return-object="true" ref="subtipoSelected" :clearable="true" hide-selected @input="obtenerValoresCatalogo()"></v-autocomplete>
                    </v-flex>
                    <v-flex col xs12 s6 m6 l6>
                        <v-autocomplete :loading="loadingValoresSubtipo" :items="valoresCatalogo" v-model="valorSelected" label="Seleccione un valor" item-text="valor" item-value="clave" :return-object="true" ref="valorSelected" :rules="
                  Object.keys(subtipoSelected).length > 0
                    ? [rules.required]
                    : []
                " hide-selected hide-no-data></v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="subtipoHint" color="error" @click.native="
                subtipoSelected = [];
                valorSelected = [];
                guardarSubtipo();
              ">
                        <v-icon>cancel</v-icon>Eliminar Subtipo
                    </v-btn>
                    <v-btn color="success" @click.native="guardarSubtipo()">
                        <v-icon>done</v-icon>Guardar
                    </v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
  
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    created: function () {
        this.getSubtipos();
        this.getUsuarios();
        this.getPerfiles();
        this.getTiposUsuario();
        if (this.$store.state.carta_porte == 1 || this.$local_storage.get("es_transportista") == 1) {
            this.breadcrumbs = [{
                    text: "Inicio",
                    disabled: false,
                    to: "/indext"
                },
                {
                    text: "Usuarios",
                    disabled: true,
                    href: ""
                }
            ]
        }
    },
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.usuarios.items;
            }

        },
    },
    data() {
        return {
            loadingValoresSubtipo: false,
            fab: [],
            name: "datagrid",
            columns: [
                "iniciales",
                "nombre",
                "email",
                "tipo_usuario",
                "perfil",
                "subtipo",
                "estatus",
                "actions"
            ],
          
            show_loading: true,
            options: {
                filterable: ["iniciales", "nombre", "email", "tipo_usuario", "perfil", "estatus"],
                sortable: ["iniciales", "nombre", "email", "tipo_usuario", "perfil", "estatus"],
                initFilters: {"estatus":'true'},
                headings: {
                    iniciales: "Iniciales",
                    nombre: "Nombre",
                    email: "Email",
                    tipo_usuario: "Tipo de Usuario",
                    perfil: "Perfil",
                    estatus: "Estatus",
                    actions: "Operaciones"
                },
                listColumns: {
                    estatus: [{
                            id: true,
                            text: "Activos"
                        },
                        {
                            id: false,
                            text: "Inactivos"
                        },
                        {
                            id: null,
                            text: "Todos"
                        }
                    ]
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    href: "/admin"
                },
                {
                    text: "Usuarios",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            titleModalPermisos: "",
            titleModalSubtipo: "",
            modal: false,
            modal_permisos: false,
            modal_subtipo: false,
            update: false,
            tipos_usuario_select: [{
                    id_tipo_usuario: 1,
                    nombre: "Administrador"
                },
                {
                    id_tipo_usuario: 2,
                    nombre: "Usuario"
                }
            ],
            tipos_usuario: [0],
            perfiles: [0],
            model: {
                id_usuario: "",
                username: "",
                password: "",
                nombre: "",
                apellidos: "",
                iniciales: "",
                tipo_usuario: "",
                perfil: "",
                estatus: true,
                cliente: "",
            },
            rules: {
                required: v => !!v || "Este campo es requerido",
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Correo electrónico no valido";
                },
                rfclen: v =>
                    (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres"
            },
            search: "",
            usuarios: {
                camposexcel: {
                    "Iniciales": "iniciales",
                    "Nombre": "nombre",
                    "Email": "email",
                    "Perfil": "perfil.nombre",
                    "Estatus": "estatus"
                },
                selected: [],
                headers: [{
                        text: "Nombre de Usuario",
                        value: "nombre"
                    },
                    {
                        text: "Email",
                        value: "email"
                    },
                    {
                        text: "Tipo de Usuario",
                        value: "tipo"
                    },
                    {
                        text: "Perfil",
                        value: "peril"
                    },
                    {
                        text: "Estatus",
                        value: "activo",
                        align: "center"
                    },
                    {
                        text: "Operaciones",
                        value: "operaciones",
                        align: "center"
                    }
                ],
                items: [{
                    perfil: 0
                }]
            },
            permisos_perfiles: [],
            permisos: {
                headers: [{
                        text: "Categoría",
                        value: "categoria"
                    },
                    {
                        text: "Permiso",
                        value: "nombre"
                    }
                ]
            },
            subtipos: [],
            subtipoSelected: [],
            valoresCatalogo: [],
            valorSelected: "",
            subtipoUsuario: 0,
            subtipoHint: false
        };
    },
    methods: {
        getNombrePerfil: function (perfil) {
            if (perfil !== null) return perfil.nombre;
        },
        getSubtipo: function (subtipo) {
            if (subtipo !== null) return subtipo;
            else return "Sin Seleccionar";
        },
        openModal: function (type) {
            if (type === 1) {
                this.title = "Nuevo Usuario";
                this.update = false;
                this.model.username = "";
                this.model.password = "";
                this.model.nombre = "";
                this.model.apellidos = "";
                this.model.iniciales = "";
                this.model.tipo_usuario = "";
                this.model.grupo = "";
            } else {
                this.title = "Actualizar Usuario";
                this.update = true;
            }

            this.modal = true;
        },
        openModalPermisos: function (perfil) {
            if (perfil === null)
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "El usuario no tiene un perfil asignado.",
                    footer: ""
                });
            else {
                this.titleModalPermisos = "Permisos del Perfil: " + perfil.nombre;
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let data = {
                    cliente: this.$local_storage.get("id_cliente"),
                    sistema: this.$sistema,
                    id_perfil: perfil.id
                };

                axios
                    .post(this.$hostname + "perfiles/get_permisos_perfil/", data)
                    .then(response => {
                        //console.log(response.data);

                        this.permisos_perfiles = this.filtrarPermisosActivos(response.data);
                        this.modal_permisos = true;
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los permisos.",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        openModalSubtipo: function (subtipo, usuario, idUsuario) {
            this.subtipoUsuario = idUsuario;
            this.titleModalSubtipo =
                "Selecciona el subtipo para el usuario: " + usuario;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            if (subtipo !== null) {
                var partes = subtipo.split(":");
                var filtrado = this.subtipos.filter(function (ele) {
                    return ele.subtipo == partes[0].trim();
                });
                this.subtipoSelected = filtrado[0];
                var valorSeleccionado = partes[1].trim();
                this.obtenerValoresCatalogo(valorSeleccionado);
                this.subtipoHint = true;
            } else {
                this.subtipoHint = false;
                this.subtipoSelected = [];
                this.valoresCatalogo = [];
                this.valorSelected = "";
                this.modal_subtipo = true;
                this.$root.$dialogLoader.hide();
            }
        },
        getSubtipos: function () {
            axios
                .get(this.$hostname + "subtipos/")
                .then(response => {
                    this.subtipos = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de subtipos.",
                        footer: ""
                    });
                });
        },
        obtenerValoresCatalogo: function (valorSeleccionado = null) {
            this.loadingValoresSubtipo = true;
            let idCliente = this.$local_storage.get("id_cliente", 0);
            var datos = {
                params: {
                    cliente: idCliente
                }
            };
            if (
                typeof this.subtipoSelected != "undefined" &&
                this.subtipoSelected != null
            ) {
                var urlsufijo = this.subtipoSelected.sufijo_url;
                var campoValor = this.subtipoSelected.campo_valor;
                var campoClave = this.subtipoSelected.campo_clave;

                axios.get(this.$hostname + urlsufijo, datos)
                    .then(response => {
                        this.valoresCatalogo = response.data.reduce(function (
                                acumulador,
                                valorActual
                            ) {
                                if (valorActual.cliente == idCliente)
                                    acumulador.push({
                                        valor: valorActual[campoValor],
                                        clave: valorActual[campoClave]
                                    });
                                return acumulador;
                            },
                            []);

                        if (valorSeleccionado != null) {
                            var filtrado = this.valoresCatalogo.filter(function (item) {
                                return item.valor == valorSeleccionado;
                            });
                            if (filtrado.length > 0) this.valorSelected = filtrado[0];
                        } else {
                            this.valorSelected = "";
                        }
                        this.modal_subtipo = true;
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener el catálogo de subtipos.",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.loadingValoresSubtipo = false;
                        this.$root.$dialogLoader.hide();
                    });
            } else {
                this.subtipoSelected = [];
                this.valoresCatalogo = [];
                this.valorSelected = "";
                this.modal_subtipo = true;
                this.$root.$dialogLoader.hide();
            }
        },
        guardarSubtipo: function () {
            var idUsuarioSubtipo = this.subtipoUsuario;
            var usuarioTieneSubtipo = this.usuarios.items.filter(function (elem) {
                return elem.id == idUsuarioSubtipo && elem.subtipo != null;
            });

            if (
                Object.keys(this.subtipoSelected).length > 0 &&
                !(Object.keys(this.valorSelected).length > 0)
            ) {
                this.$nextTick(() => this.$refs.valorSelected.focus());
            } else if (
                (usuarioTieneSubtipo.length > 0 &&
                    !(Object.keys(this.valorSelected).length > 0)) ||
                Object.keys(this.valorSelected).length > 0
            ) {
                let idCliente = this.$local_storage.get("id_cliente");
                let subtipo =
                    Object.keys(this.subtipoSelected).length > 0 ?
                    this.subtipoSelected :
                    null;
                let valor =
                    Object.keys(this.valorSelected).length > 0 ?
                    this.valorSelected :
                    null;
                let data = {
                    usuario: this.subtipoUsuario,
                    cliente: idCliente,
                    sistema: this.$sistema,
                    catalogo_campo_clave: subtipo != null ? subtipo.campo_clave : null,
                    catalogo_subtipo: subtipo != null ? subtipo.subtipo : null,
                    catalogo_tabla: subtipo != null ? subtipo.tabla : null,
                    catalogo_valor: valor != null ? valor.valor : null,
                    catalogo_valor_clave: valor != null ? valor.clave : null
                };
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios
                    .post(this.$hostname + "clientes/update_subtipo_cliente/", data)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El cliente se actualizó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al actualizar el cliente",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.modal_subtipo = false;
                        this.getUsuarios();
                        this.$root.$dialogLoader.hide();
                    });
            } else {
                this.$nextTick(() => this.$refs.subtipoSelected.focus());
            }
        },
        filtrarPermisosActivos: function (arr) {
            return arr
                .filter(function (ele) {
                    return ele.activo == 1;
                })
                .sort(this.ordenarArrayPermisos);
        },
        ordenarArrayPermisos: function (a, b) {
            if (a.ordenar > b.ordenar) return 1;
            if (a.ordenar < b.ordenar) return -1;
            return 0;
        },
        getUsuarios: function () {
            let idCliente = this.$local_storage.get("id_cliente");

            let data = {
                cliente: idCliente,
                sistema: this.$sistema
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.$hostname + "usuarios/obtener_usuarios_cliente/", data)
                .then(response => {
                    
                    this.usuarios.items = response.data.filter(item => {
                                                    return item.perfil != null &&  item.perfil.nombre.includes('SA31') > 0
                                                });

                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },
        getPerfiles: function () {

            let idCliente = this.$local_storage.get("id_cliente");
            let data = {
                "cliente": idCliente
            };
            axios
                .post(this.$hostname + "perfiles/get_perfiles_cliente/", data)
                .then(response => {

                    this.perfiles = response.data;
                       this.perfiles = response.data.filter(item => {
                                                    return item.nombre.includes('SA31') > 0
                                                });
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los perfiles.",
                        footer: ""
                    });
                });
        },
        getTiposUsuario: function () {
            axios
                .post(this.$hostname + "tipos-usuarios/get_all/")
                .then(response => {
                    let datos = response.data.filter(function (tipo) {
                        return tipo.nombre == "Cliente";
                    });

                    this.tipos_usuario = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de usuario.",
                        footer: ""
                    });
                });
        },
        getUsuario: function (id_usuario) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "usuarios/" + id_usuario + "/")
                .then(response => {
                    this.model.id_usuario = response.data.id_usuario;
                    this.model.username = response.data.username;
                    this.model.nombre = response.data.nombre;
                    this.model.apellidos = response.data.apellidos;
                    this.model.iniciales = response.data.iniciales;
                    this.model.tipo_usuario = 1;

                    let perfil = response.data.perfiles.filter(perfil => {
                        return perfil.id_sistema == this.$sistema;
                    });

                    if (perfil.length == 1) {
                        this.model.perfil = perfil[0].id_perfil;
                        this.model.tipo_usuario = 2;
                    }
                    this.$root.$dialogLoader.hide();
                    this.openModal(2);
                })
                .catch(error => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener al usuario",
                        footer: ""
                    });
                });
        },
        saveUsuario: function () {
            if (this.$refs.form.validate()) {
                let tipo = this.tipos_usuario.filter(function (tipo) {
                    return tipo.nombre == "Cliente";
                });

                let idCliente = this.$local_storage.get("id_cliente");
                let data = {
                    username: this.model.username,
                    password: this.model.username,
                    nombre: this.model.nombre,
                    apellidos: this.model.apellidos,
                    iniciales: this.model.iniciales,
                    tipo_usuario: this.model.tipo_usuario,
                    estatus: true,
                    cliente: idCliente,
                    sistema: this.$sistema
                };

                if (data.tipo_usuario == 2) data.perfil = this.model.perfil;

                data.tipo_usuario = tipo[0].id_tipo_usuario;
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios
                    .post(this.$hostname + "usuarios/", data, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    })
                    .then(response => {

                        this.showNotificacionUsuario(this.model.nombre, this.model.username);

                        this.modal = false;
                        this.getUsuarios();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: error.response.data.username,
                            footer: ""
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        updateUsuario: function () {
            let id_usuario = this.model.id_usuario;

            if (this.$refs.form.validate()) {
                let tipo = this.tipos_usuario.filter(function (tipo) {
                    return tipo.nombre == "Cliente";
                });

                let idCliente = this.$local_storage.get("id_cliente");
                let data = {
                    nombre: this.model.nombre,
                    apellidos: this.model.apellidos,
                    iniciales: this.model.iniciales,
                    sistema: this.$sistema,
                    cliente: idCliente
                };

                data.tipo_usuario = tipo[0].id_tipo_usuario;
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios
                    .put(this.$hostname + "usuarios/" + id_usuario + "/", data)
                    .then(response => {
                        data = {
                            usuario: id_usuario,
                            tipo_usuario: tipo[0].id_tipo_usuario,
                            cliente: idCliente
                        };

                        if (this.model.tipo_usuario == 2) data.perfil = this.model.perfil;

                        axios
                            .put(this.$hostname + "usuarios/cambiar_tipo_usuario/", data)
                            .then(response => {
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El usuario se actualizó correctamente.",
                                    footer: ""
                                });

                                this.getUsuarios();
                                this.modal = false;
                            })
                            .catch(error => {
                                let msj = error.response.data.mensaje;

                                if (msj === undefined) msj = error.response.data.username;

                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: msj,
                                    footer: ""
                                });
                            });
                    })
                    .catch(error => {
                        let msj = error.response.data.detail;

                        if (msj === undefined) msj = error.response.data.username;

                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: msj,
                            footer: ""
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        deleteUsuario: function (id_usuario) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.$hostname + "usuarios/" + id_usuario + "/", {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El usuario se eliminó correctamente.",
                            footer: ""
                        });

                        this.getUsuarios();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar al usuario",
                            footer: ""
                        });
                    });
            });
        },
        resetPassword: function (id_usuario, email) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Realmente desea resetear la contraseña?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                let idCliente = this.$local_storage.get("id_cliente");

                let data = {
                    cliente: idCliente,
                    sistema: this.$sistema,
                    password: email
                };

                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    axios
                        .put(this.$hostname + "usuarios/" + id_usuario + "/", data, {
                            "Content-type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "cache-control": "no-cache"
                        })
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "La contraseña se reseteó correctamente",
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al resetear la contraseña",
                                footer: ""
                            });
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        },
        changeEstatus: function (id_usuario, id_usuario_cliente, estatus) {
            let msj = estatus ? "Activar" : "Desactivar";

            axios
                .get(this.$hostname + "usuarios/" + id_usuario + "/")
                .then(response => {
                    this.model = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener al usuario",
                        footer: ""
                    });
                });

            this.$swal({
                type: "question",
                title: "Cuidado",
                text: "¿Está seguro de " + msj + " el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {

                let data = {
                    estatus: estatus,
                    id_usuario_cliente: id_usuario_cliente
                };

                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        //Cambia el estatus de la tabla usuarios_clientes
                        .post(this.$hostname + "usuarios/cambiar_estatus/", data)
                        .then(response => {
                            this.getUsuarios();
                            if (msj == 'Activar') {
                                this.showNotificacionUsuario(this.model.nombre, this.model.username);
                            }
                        })
                        .catch(error => {
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al actualizar el estatus del usuario",
                                footer: ""
                            });
                        });
                }
            });
        },

        showNotificacionUsuario(nombre, correo) {
            var fecha = moment(new Date()).format("DD/MM/YYYY");
            this.$swal({
                type: "info",
                title: "Notificación",
                html: "Se ha configurado acceso para el usuario:  <span style='font-weight: bold;'>" + nombre + "</span>, " +
                    "con cuenta de correo electrónico <span style='font-weight: bold;'>" + correo + "</span>, a partir de esta fecha: <span style='font-weight: bold;'>" + fecha + "</span>. " +
                    "Le sugerimos confirmar los permisos concedidos a través del módulo: 'PERFIL DE USUARIO' " +
                    "para concluir exitosamente con la cuenta habilitada. " +
                    "<br/><br/>Es responsabilidad de la empresa a través de su usuario 'Cliente-Administrador' el control de acceso a la plataforma, " +
                    "así como las actividades que puedan realizar conforme a su perfil autorizado.",
                footer: "",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showCancelButton: false,
                confirmButtonText: "Aceptar",
            });
        },
        logout: function function_name(id_usuario) {
            var data = {
                usuario: id_usuario,
                sistema: this.$sistema,
                avatar: "undefined"
            };

            var url = this.$hostname + "usuarios/logout/";
            var self = this;

            axios
                .post(url, data)
                .then(function (response) {
                    self.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "La sesión del usuario se cerro correctamente",
                        footer: ""
                    });
                })
                .catch(function (error) {
                    self.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cerrar la sesión",
                        footer: ""
                    });
                });
        }
    }
};
</script>
